import { observer } from 'mobx-react';
import React from 'react';
import { promocodeStore } from '../../store/promocodeStore';
import { IWeekModalSaveParams } from 'src/mobx/modalStore/types';
import WeekModalOpen from 'src/view/containers/Modals/WeekModal/components/WeekModalOpen/WeekModalOpen';
import { appStore } from '~/mobx/appStore';
import Text from '~/view/components/Text/Text';
import { TimePickerMode } from '~/constants/dateTime';

@observer
export default class PromocodeValidity extends React.Component<{}, {}> {
  changeDate = (data: IWeekModalSaveParams) => {
    promocodeStore.changePromocode(
      {
        start_date: data.startDate,
        end_date: data.endDate,
        start_time: data.startTime,
        end_time: data.endTime,
        is_all_day: data.allDay,
        days_of_week: data.daysOfWeek,
      },
      true
    );
  };

  render() {
    return (
      <div className="d-flex flex-column mt-6">
        <Text type="block-header" text="validity" required />
        <div className="d-flex flex-row mt-2 promocode_large_field">
          <WeekModalOpen
            startDate={promocodeStore.promocode.start_date}
            endDate={promocodeStore.promocode.end_date}
            startTime={promocodeStore.promocode.start_time}
            endTime={promocodeStore.promocode.end_time}
            allDay={promocodeStore.promocode.is_all_day}
            daysOfWeek={promocodeStore.promocode.days_of_week}
            onSave={this.changeDate}
            className={promocodeStore.isValid.start_date || promocodeStore.isValid.end_date ? undefined : 'input-error'}
            hideAdditionalSettings={!appStore.isAddonsAvailable.promoCode}
            timePickerMode={TimePickerMode.GENERAL}
            minimumOneDayInWeek
          />
        </div>
      </div>
    );
  }
}
